import actions from '../../../sharedmodules/actions-list';
import { handleError } from '../../../sharedmodules/services/error-handlers';
import { readNotification } from '../repositories/readNotification';

export const readNotificationData = (getAccessToken) => async (dispatch) => {

    try {

        const notificationData = await readNotification(getAccessToken);
        dispatch({
            data: notificationData,
            type: actions.GET_NOTIFICATION_DATA,
        });

    } catch (error) {

        handleError(error);

    }

};
